import app from 'flarum/forum/app';
import TextEditorButton from 'flarum/common/components/TextEditorButton';
app.initializers.add('val-ui-fof-upload-tooltip', () => {
  const originalInitAttrs = TextEditorButton.initAttrs;
  TextEditorButton.initAttrs = function (attrs) {
    originalInitAttrs.call(this, attrs);

    /*
     * TextEditorButton copie d'abord title dans tooltipText.
     * On peut donc ensuite supprimer title sans perdre
     * la tooltip Flarum.
     */
    if (typeof attrs.className === 'string' && attrs.className.includes('fof-upload-button')) {
      delete attrs.title;
    }
  };
});